<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">
              Departman Yetkileri
              <small>({{ department.name }})</small>
            </h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <router-link tag="li" to="/departments" class="breadcrumb-item"
                ><a>Departmanlar</a></router-link
              >
              <li class="breadcrumb-item active">Departman Yetkileri</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card" style="min-height: 750px">
              <div class="card-header card-title">
                İşlem Yetki Ayarları
                <button
                  class="float-right btn btn-outline-danger btn-sm"
                  style="margin-left: 5px"
                  @click="allDeleteModule"
                >
                  <i class="fas fa-trash"></i> Tüm Yetkileri Sil
                </button>

                <button
                  class="float-right btn btn-outline-primary btn-sm"
                  @click="allAddModule"
                >
                  <i class="fas fa-plus"></i> Tüm İşlemlere Yetki Ver
                </button>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <small class="text-danger"
                      >* Sadece yetkili olan işlemlerde kullanıcı işlem yapma
                      iznine sahip olacaktır. <b> Yöneticiler </b> tüm işlemlere
                      erişebilirler.
                    </small>
                    <hr />
                  </div>

                  <div class="col-12">
                    <div class="overlay-wrapper">
                      <div class="overlay" v-if="overlay">
                        <i class="fas fa-3x fa-spinner fa-spin"></i>
                      </div>
                      <input
                        class="form-control"
                        v-model="search"
                        placeholder="Yetki Ara"
                      />
                      <br />
                      <ul
                        class="list-group"
                        style="
                          max-height: 500px;
                          overflow-x: hidden;
                          overflow-y: scrool;
                        "
                      >
                        <li
                          class="list-group-item"
                          v-for="item in filtered"
                          :key="item.id"
                        >
                          <div class="row">
                            <div class="col">{{ item.name }}</div>
                            <div class="col">
                              <div class="icheck-primary d-inline">
                                <input
                                  type="checkbox"
                                  :id="'ckr' + item.id"
                                  @change="ckrChange(item)"
                                  :checked="item.isRead"
                                  :disabled="item.isWrite"
                                />
                                <label :for="'ckr' + item.id">
                                  Görüntüleme İzni
                                </label>
                              </div>
                            </div>
                            <div class="col">
                              <div class="icheck-primary d-inline">
                                <input
                                  type="checkbox"
                                  :id="'ckw' + item.id"
                                  @change="ckwChange(item)"
                                  :checked="item.isWrite"
                                />
                                <label :for="'ckw' + item.id">
                                  Değişiklik İzni
                                </label>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li
                          v-if="filtered.length == 0"
                          class="list-group-item text-center"
                        >
                          Kayıt Bulunamadı
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-md-6 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      search: "",
      modules: [],
      overlay: false,
      department: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    getDepartments() {
      this.overlay = true;

      this.$http
        .get("Department/GetDepartment/" + this.$route.params.id)
        .then((response) => {
          this.department = response.data;
          this.overlay = false;
        });
    },

    getModules() {
      this.overlay = true;

      this.$http
        .get("Module/ListDepartmentModules/" + this.$route.params.id)
        .then((response) => {
          this.modules = response.data;
          this.overlay = false;
        });
    },

    ckwChange(item) {
      let url = "DepartmentModule/AddDepartmentModules";

      if (item.isWrite) url = "DepartmentModule/DeleteDepartmentModules";

      this.$http
        .post(url, {
          department: this.$route.params.id,
          module: item.id,
          isRead: !item.isWrite ? true : item.isRead,
          isWrite: !item.isWrite,
        })
        .then((response) => {
          if (response.status == 200) {
            toastr.success("Kayıt başarılı.");
            $("#modal").modal("hide");
            this.getModules();
          }
        });
    },
    ckrChange(item) {
      let url = "DepartmentModule/AddDepartmentModules";

      if (item.isRead) url = "DepartmentModule/DeleteDepartmentModules";

      this.$http
        .post(url, {
          department: this.$route.params.id,
          module: item.id,
          isRead: !item.isRead,
          isWrite: item.isWrite,
        })
        .then((response) => {
          if (response.status == 200) {
            toastr.success("Kayıt başarılı.");
            $("#modal").modal("hide");
            this.getModules();
          }
        });
    },
    allAddModule() {
      this.$http
        .get("DepartmentModule/AllAddDepartmentModule/" + this.$route.params.id)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
    allDeleteModule() {
      this.$http
        .get(
          "DepartmentModule/AllDeleteDepartmentModule/" + this.$route.params.id
        )
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
  },
  computed: {
    filtered() {
      return this.modules.filter((value) => {
        return value.name.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.getDepartments();

    this.getModules();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Department/DepartmentAuthority.vue